// extracted by mini-css-extract-plugin
module.exports = {"center":"+-mqZBmZIP+B65a3BQnRIw=="};